import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import LoadingOverlay from "./LoadingOverlay";

const LANGUAGES = [
  { code: "en", label: "English", country: "US", direction: "ltr" },
  { code: "ar", label: "العربية", country: "IQ", direction: "rtl" },
];

const DOMAIN = window.location.hostname === "localhost" ? ".localhost" : ".justenant.com";

export default function LangButton() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Clear any stale googtrans cookie that causes Google Translate to interfere
    document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `googtrans=; path=/; domain=${DOMAIN}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

    const lang = i18n.language;
    setCurrentLang(lang);
    const langObj = LANGUAGES.find((l) => l.code === lang);
    document.body.dir = langObj?.direction || "ltr";
    document.documentElement.lang = langObj?.code || "en";
  }, []);

  const changeLanguage = (lang) => {
    setCurrentLang(lang);
    setLoading(true);
    i18n.changeLanguage(lang); // automatically saves to localStorage via LanguageDetector

    const langObj = LANGUAGES.find((l) => l.code === lang);
    document.body.dir = langObj?.direction || "ltr";
    document.documentElement.lang = langObj?.code || "en";

    setTimeout(() => {
      const cleanUrl = window.location.origin + window.location.pathname;
      window.location.href = cleanUrl;
    }, 300);
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <Box
        sx={{
          mt: 4,
          display: "flex",
          justifyContent: "center",
          fontSize: "1rem",
          fontWeight: 500,
          color: "#94a3b8",
          gap: 1,
          userSelect: "none",
        }}
      >
        {LANGUAGES.map(({ code, label, country }) => {
          const isSelected = currentLang === code;
          return (
            <React.Fragment key={code}>
              <Button
                onClick={() => changeLanguage(code)}
                className="notranslate"
                sx={{
                  minWidth: "auto",
                  px: 1,
                  color: isSelected ? "#00b4d8" : "#94a3b8",
                  textTransform: "none",
                  fontWeight: isSelected ? 600 : 400,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#00b4d8",
                  },
                }}
              >
                <Typography component="span" fontSize={14}>
                  {label}
                </Typography>
              </Button>
              {code !== LANGUAGES[LANGUAGES.length - 1].code && (
                <span
                  style={{
                    alignSelf: "center",
                    color: "#94a3b8",
                    userSelect: "none",
                  }}
                >
                  |
                </span>
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </>
  );
}
